(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(root) {
    root.querySelectorAll('video[data-sh-autoplay]').forEach(function (v) {
      var btn = v.parentElement.querySelector('[data-sh-video-toggle]');
      function setBtn(paused) {
        if (!btn) return;
        btn.setAttribute('aria-label', paused ? 'Play background video' : 'Pause background video');
        btn.innerHTML = paused
          ? '<svg viewBox="0 0 14 14" aria-hidden="true"><path d="M3 1.5v11l9-5.5z"/></svg>'
          : '<svg viewBox="0 0 14 14" aria-hidden="true"><rect x="2" y="1" width="3.5" height="12"/><rect x="8.5" y="1" width="3.5" height="12"/></svg>';
      }
      if (reduce) { v.removeAttribute('autoplay'); v.pause(); setBtn(true); }
      if (btn && !btn.dataset.shReady) {
        btn.dataset.shReady = '1';
        btn.addEventListener('click', function () {
          if (v.paused) { var r = v.play(); if (r && r.catch) r.catch(function () {}); setBtn(false); } else { v.pause(); setBtn(true); }
        });
      }
    });
    root.querySelectorAll('[data-sh-player]').forEach(function (p) {
      if (p.dataset.shReady) return; p.dataset.shReady = '1';
      var b = p.querySelector('.sh-play'), v = p.querySelector('video');
      if (!b || !v) return;
      b.addEventListener('click', function () {
        p.classList.add('is-playing'); v.controls = true; v.muted = false;
        var r = v.play(); if (r && r.catch) r.catch(function () {});
      });
    });
    root.querySelectorAll('[data-sh-scroll]').forEach(function (b) {
      if (b.dataset.shReady) return; b.dataset.shReady = '1';
      b.addEventListener('click', function () {
        var rail = document.getElementById(b.getAttribute('aria-controls'));
        if (rail) rail.scrollBy({ left: (+b.dataset.shScroll) * rail.clientWidth * 0.75, behavior: reduce ? 'auto' : 'smooth' });
      });
    });
    root.querySelectorAll('[data-sh-carousel]').forEach(function (f) {
      if (f.dataset.shReady) return; f.dataset.shReady = '1';
      var slides = [].slice.call(f.querySelectorAll('.sh-fam__slide'));
      var dots = f.querySelector('.sh-fam__dots'), pauseBtn = f.querySelector('[data-sh-pause]');
      var i = 0, timer = null, userPaused = false, hovering = false, focused = false, DELAY = 5000;
      if (slides.length < 2) { var c = f.querySelector('.sh-fam__ctrl'); if (c) c.hidden = true; return; }
      slides.forEach(function (s, k) {
        var d = document.createElement('button');
        d.className = 'sh-fam__dot'; d.type = 'button'; d.setAttribute('aria-label', 'Show photo ' + (k + 1));
        d.addEventListener('click', function () { go(k); schedule(); });
        dots.appendChild(d);
      });
      function go(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-on', k === i); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
        [].forEach.call(dots.children, function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      }
      function schedule() {
        clearTimeout(timer);
        if (userPaused || hovering || focused || document.hidden) return;
        timer = setTimeout(function () { go(i + 1); schedule(); }, DELAY);
      }
      function setPaused(p) {
        userPaused = p;
        if (pauseBtn) {
          pauseBtn.setAttribute('aria-label', p ? 'Play slideshow' : 'Pause slideshow');
          pauseBtn.innerHTML = p
            ? '<svg viewBox="0 0 14 14" aria-hidden="true"><path d="M3 1.5v11l9-5.5z"/></svg>'
            : '<svg viewBox="0 0 14 14" aria-hidden="true"><rect x="2" y="1" width="3.5" height="12"/><rect x="8.5" y="1" width="3.5" height="12"/></svg>';
        }
        schedule();
      }
      f.querySelectorAll('.sh-arrow').forEach(function (b) { b.addEventListener('click', function () { go(i + (+b.dataset.dir)); schedule(); }); });
      if (pauseBtn) pauseBtn.addEventListener('click', function () { setPaused(!userPaused); });
      f.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { hovering = true; schedule(); } });
      f.addEventListener('pointerleave', function () { hovering = false; schedule(); });
      f.addEventListener('focusin', function () { focused = true; schedule(); });
      f.addEventListener('focusout', function (e) { if (!f.contains(e.relatedTarget)) { focused = false; schedule(); } });
      document.addEventListener('visibilitychange', schedule);
      go(0); schedule();
    });
  }
  function fixRecentOrderPopup() {
    var a = document.querySelector('#sro-popup .sro-image > a');
    if (a && !a.hasAttribute('data-sh-fixed')) { a.setAttribute('data-sh-fixed', ''); a.setAttribute('tabindex', '-1'); a.setAttribute('aria-hidden', 'true'); }
  }
  new MutationObserver(fixRecentOrderPopup).observe(document.documentElement, { childList: true, subtree: true });
  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
